import React from "react"
import { useSelector } from "react-redux"
import MainPaper from "src/features/Components/MainPaper"
import { makeStyles } from "@material-ui/core/styles"
import { get } from "lodash"
import Typography from "@material-ui/core/Typography"
import Grid from "@material-ui/core/Grid"
import Avatar from "@material-ui/core/Avatar"
import NoImage from "src/assets/no-image.jpg"

const useStyles = makeStyles((theme) => ({
  root: { marginBottom: theme.spacing(2) },
  title: { marginBottom: theme.spacing(2) },
  avatar: { width: 100, height: 100 },
  category_tag: {
    borderRadius: 5,
    color: "#B2B4BC",
    backgroundColor: "#191D3A",
    padding: "4px 20px",
  },
}))

function Index() {
  const classes = useStyles()
  const detail = useSelector((state) => state.supply.detail)

  return (
    <MainPaper elevation={0} className={classes.root}>
      <Grid container justifyContent="space-between">
        <Grid item>
          <Grid container spacing={1} alignItems="center">
            <Grid item>
              <Typography variant="h6">
                {get(detail, "supply.search_name")}
              </Typography>
            </Grid>
            {get(detail, "supply.category", []).map((item, key) => (
              <Grid item key={key}>
                <Typography variant="caption" className={classes.category_tag}>
                  {item.name}
                </Typography>
              </Grid>
            ))}
          </Grid>
          <Typography variant="body2" gutterBottom>
            {get(detail, "multiplier")} / {get(detail, "container.name")}
          </Typography>
          <Typography variant="body2">
            {get(detail, "supply.distributor[0].full_name")}
          </Typography>
          <Typography variant="body2">
            {get(detail, "station.full_name")} ● {get(detail, "barcode")}
          </Typography>
        </Grid>
        <Grid item>
          <Avatar
            className={classes.avatar}
            variant="rounded"
            src={get(detail, "cover_img") || NoImage}
          />
        </Grid>
      </Grid>
    </MainPaper>
  )
}

export default Index
